import { render } from "./OverviewHistory.vue?vue&type=template&id=52e9eb6e"
import script from "./OverviewHistory.vue?vue&type=script&lang=js"
export * from "./OverviewHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__